import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store/store";
import "./plugins/element.js";
import locale from "element-ui/lib/locale";
import VueI18n from "vue-i18n";
import zhLocale from "element-ui/lib/locale/lang/zh-CN";
import zhTwLocale from "element-ui/lib/locale/lang/zh-TW";
import echarts from "echarts";
import ApiService from "./utils/http";
import Tool from "./utils/tool";
import Common from "./utils/common";
import axios from "axios";
import Urls from "./urlLink";
import zh_cn from "./locales/zh-cn.json";
import tw_cn from "./locales/tw-cn.json";
import "@/utils/update";
import { Message, Loading } from "element-ui";
import { getTokenincHolder, flattenJavaEnvelope } from "./utils/apiResponse";
import {
  setupVueGlobals,
  resolveLocaleLanguage,
  buildUserInfo,
  applyUserContext,
} from "./bootstrap/appContext";
import { syncRouteStateFromStorage, bootstrapStoreFromStorage } from "./bootstrap/routerState";
import { createLoadingManager } from "./bootstrap/loadingManager";
import { registerHttpInterceptors } from "./bootstrap/httpInterceptors";

setupVueGlobals({
  Vue,
  Tool,
  Common,
  echarts,
  ApiService,
  Urls,
});

const localeLang = resolveLocaleLanguage(Tool);
const userInfo = buildUserInfo(Tool, localeLang);
applyUserContext(Vue, userInfo);

Vue.use(VueI18n);
const i18n = new VueI18n({
  locale: localeLang,
  messages: {
    zh: Object.assign(require("./langs/cn.js"), zhLocale, zh_cn),
    tw: Object.assign(require("./langs/tw.js"), zhTwLocale, tw_cn),
  },
});
locale.i18n((key, value) => i18n.t(key, value));

router.beforeEach((_to, _from, next) => {
  syncRouteStateFromStorage({ Tool, store });
  next();
});

const loadingManager = createLoadingManager({ Loading, i18n });
export const showFullScreenLoading = loadingManager.showFullScreenLoading;
export const tryHideFullScreenLoading = loadingManager.tryHideFullScreenLoading;

registerHttpInterceptors({
  axios,
  Tool,
  i18n,
  Urls,
  Message,
  flattenJavaEnvelope,
  getTokenincHolder,
  showFullScreenLoading,
  tryHideFullScreenLoading,
});

export default axios;

if (localStorage.getItem("staffer_id") != "undefined") {
  bootstrapStoreFromStorage({ Tool, store, router });
}

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");

